import { createGlobalStyle } from 'styled-components'


export const GlobalStyle = createGlobalStyle`

    :root {
    --header-height: 3.5rem;

    /*========== Colors ==========*/
    /*Color mode HSL(hue, saturation, lightness)*/
    --first-color: hsl(207, 65%, 65%);
    --title-color: hsl(207, 4%, 16%);
    --text-color: hsl(207, 4%, 28%);
    --text-color-light: hsl(207, 4%, 56%);
    --body-color: hsl(207, 4%, 99%);
    --container-color: hsl(207, 4%, 95%);
    /* --container-color: red; */
    
    /* Change the first number */
    /* Blue: 207-Purple: 250-Pink: 356-Teal: 174 */
    --gradient-color: linear-gradient(180deg,
      hsla(207, 48%, 72%, 0),
      hsla(207, 65%, 65%, 1));
      
      /*========== Font and typography ==========*/
      /*.5rem = 8px | 1rem = 16px ...*/
      --body-font: 'Cabin', sans-serif;
      --title-font: 'Sniglet', cursive;
      --biggest-font-size: 1.5rem;
      --h1-font-size: 1.5rem;
      --h2-font-size: 1.25rem;
      --h3-font-size: 1rem;
    --normal-font-size: 1rem;
    --small-font-size: .85rem;
    --smaller-font-size: .75rem;
    --tiny-font-size: .625rem;

    /*========== Font weight ==========*/
    --font-medium: 500;
    --font-semi-bold: 600;
    
    /*========== z index ==========*/
    --z-normal: 1;
    --z-tooltip: 10;
    --z-fixed: 100;
  }
  
  /* Responsive typography */
  @media screen and(min-width: 1024px) {
    :root {
      --biggest-font-size: 3.5rem;
      --h1-font-size: 2.25rem;
      --h2-font-size: 1.5rem;
      --h3-font-size: 1.25rem;
      --normal-font-size: 1rem;
      --small-font-size: .9rem;
      --smaller-font-size: .81rem;
      --tiny-font-size: .7rem;
    }
}

      /*=============== BASE ===============*/
      * {
    box-sizing: border-box;
padding: 0;
margin: 0;
      }
      
      html {
    scroll-behavior: smooth;
}
      
      body {
    font-family: var(--body-font);
    font-size: var(--normal-font-size);
    background-color: var(--body-color);
    color: var(--text-color);
    transition: background-color .4s; /* for dark mode animation */
}

h1, h2, h3 {
    color: var(--title-color);
    font-family: var(--title-font);
    font-weight: var(--font-medium);
}
      
      ul {
    list-style: none;
}
      
      a {
    text-decoration: none;
}
      
      img {
    max-width: 100%;
    height: auto;
}

/*=============== THEME ===============*/


/*========== Variables Dark theme ==========*/
body.dark-theme {
    --title-color: hsl(207, 4%, 95%);
    --text-color: hsl(207, 4%, 65%);
    --body-color: hsl(207, 4%, 10%);
    --container-color: hsl(207, 4%, 12%);
}

      /*========== 
          Color changes in some parts of 
          the website, in light theme
      ==========*/


      /*=============== REUSABLE CSS CLASSES ===============*/
      .container {
    max-width: 1024px;
    margin-inline: 1.5rem;
}
      
      .grid {
    display: grid;
    gap: 1.5rem;
}
      
      .section {
    padding-block: 2.5rem;
}
      
      .section__border {
    border-bottom: 1px solid var(--title-color);
    padding-bottom: 3.5rem;
}
      
      .section__title, 
      .section__subtitle {
    text-align: center;
}
      
      .section__title {
    font-size: var(--h1-font-size);
    font-weight: var(--font-semi-bold);
    margin-bottom: .25rem;
}
      
      .section__subtitle {
    display: block;
    font-size: var(--small-font-size);
    color: var(--text-color-light);
    margin-bottom: 3rem;
}
      
      .main {
    overflow: hidden; /* For animation */

    .scrollup{
      position: fixed;
      right: 2rem;
      bottom: -30%;
      background-color: var(--body-color);
      box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
      display: inline-flex;
      padding: 0.5rem;
      border-radius:.25rem;
      font-size: 1.25rem;
      font-weight: bold;
      color: var(--title-color);
      z-index: var(--z-tooltip);
      transition: bottom .3s, transform 0.3s;

      &:hover{
        transform: translateY(-.25rem);
      }
    }
    .show-scroll{
      bottom: 7.5rem;
    }

    .css-1t1j96h-MuiPaper-root-MuiDialog-paper{
      border: 2px solid red;
    }

}

.dark-theme .nav,.dark-theme .nav__menu, .dark-theme .scrollup{
  background-color: var(--container-color);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}

.dark-theme .home__shape-wawes,
.dark-theme .home__shape-circle,
.dark-theme .testimonial__img{
  filter: invert(1);
}

.dark-theme .nav,
    .dark-theme .nav__menu{
        background-color: var(--body-color);
        box-shadow: #ffffff1c 0px 5px 15px 0px;
    }

.dark-theme .home__social-link{
  color: var(--title-color);
}

.dark-theme .section__border{
  border-bottom: 1px solid hsl(207, 4%,32%);
}

.dark-theme::-webkit-scrollbar{
  background-color: hsl(207,4%,15%);
}
.dark-theme::-webkit-scrollbar-thumb{
  background-color: hsl(207,4%,25%);
  
  &:hover{
    background-color: hsl(207,4%,35%);
  }
}



.section .home__title{
  font-size: 2.25rem;
  width: fit-content;
  margin: 3rem auto 1rem;
  padding-left: 1.5rem;
}

      /*=============== SCROLL BAR ===============*/

    ::-webkit-scrollbar{
      width: 0.6rem;
      border-radius: 0.5rem;
      background-color: hsl(207,4%,75%);
    }

    ::-webkit-scrollbar-thumb{
      background-color: hsl(207,4%,65%);
      border-radius: 0.5rem;
    }

    ::-webkit-scrollbar-thumb:hover{
      background-color: hsl(207,4%,55%);
    }

    .resume{
      width: fit-content;
      margin: 3rem auto 0;

            button{
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 1rem;
                padding: 0.8rem 2rem;
                font-size: var(--body-font-size);
                border: none;
                background-color: var(--text-color-light);
                color: var(--body-color);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                border-radius: .5rem;
                transition: all 0.2s;

                &:hover{
                    background-color: var(--title-color);
                    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
                }
                i{
                    font-size: 1.25rem;
                    color: var(--body-color);
                }
            }
        }

      /*=============== BREAKPOINTS ===============*/
      /* For small devices */

      @media screen and (max-width: 340px){
        .container{
          margin-inline: 1rem;
        }
        .nav__menu{
          padding-bottom: 4rem;
          .nav__list{
            gap: 2rem 2rem;
          }
        }
        
      }


      /* For medium devices */

      /* For large devices */

      @media screen and (min-width: 1024px){
        .nav{
          .nav__logo{
            font-size: 1.25rem;
          }
        }
        .dark-theme .nav,
        .dark-theme .nav__menu{
            background-color: var(--body-color);
            box-shadow: none;
        }
        .change-theme{
          color: var(--text-color-light);

          &:hover{
            color: var(--title-color);
          }
        }

        .section{
          padding: 6rem 0;
          .home__title{
            font-size: 2.5rem;
          }

        }
        .main{
          .scrollup{
            right: 3rem;
          }
          .show-scroll{
            bottom: 6rem;
          }

          
        }


      }


      @media screen and (min-width: 1200px){
        .container{
          margin-inline: auto;
        }
        .nav{
          .nav__logo{
            font-size: 1.5rem;
          }
        }
        .section__border{
            padding-bottom: 6rem;
        }
        .section__subtitle{
            margin-bottom: 5rem;
            font-size: 1.15rem;
        }
        .section__title{
          font-size: 1.95rem;
        }
        .home__title{
            font-size: var(--biggest-font-size);
        }
    }
`